// extracted by mini-css-extract-plugin
export default {"googleIcon":"googleIcon__ea4SR","header":"header__l2DY9"};